import * as React from 'react';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { useLocalizer } from './hooks/useLocalizer';
import { formatFileSize, calculateFileSummary } from '../../../utilities/fileUtils';
import { UploadedFile } from './types';
import AIReadOnlyFileList from './AIReadOnlyFileList';

interface AIImportedFilesSectionProps {
    uploadedFiles: UploadedFile[];
    localizer?: IStringLocalizer;
}

export const AIImportedFilesSection: React.FC<AIImportedFilesSectionProps> = ({
    uploadedFiles,
    localizer
}) => {
    const localize = useLocalizer(localizer);
    
    if (uploadedFiles.length === 0) {
        return null;
    }

    const { totalSize, fileTypes } = calculateFileSummary(uploadedFiles);

    return (
        <div className="ai-imported-files-section">
            <h4 className="ai-imported-files-title">
                {uploadedFiles.length} {localize("Files Imported")}
                <span className="ai-imported-files-meta">
                    {formatFileSize(totalSize)} • {fileTypes}
                </span>
            </h4>
            <AIReadOnlyFileList files={uploadedFiles} />
        </div>
    );
};

export default AIImportedFilesSection;
